module.exports = __webpack_public_path__ + "assets/img/6.a3705f68.png";